import React, { Component } from 'react';
import WorkerCard from '../../components/WorkerCard';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Preloader from '../../components/Preloader';
import ErrorMessage from '../../components/ErrorMessage';
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadWorker } from '../../actions/WorkerActions';

class PageWorkerCard extends Component {
  static requestData(store, match) {
    return requestAll([() => loadWorker(match.params.workerCard)], store);
  }

  componentDidMount() {
    this.props.actions.loadWorker(this.props.match.params.workerCard);
  }
  render() {
    if ((this.props.hasErrored) || (this.props.worker.length < 1)) {
      return <ErrorMessage/>;
    }

    if (this.props.isLoading) {
       return <Preloader/>;
    }
    return (
      <WorkerCard openVacancy={true} {...this.props} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
      baseCity: state.baseCity,
      worker: state.worker.item,
      hasErrored: state.worker.hasErrored,
      isLoading: state.worker.isLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadWorker }, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageWorkerCard));


// WEBPACK FOOTER //
// ./src/pages/PageWorkerCard/index.js